import { render, staticRenderFns } from "./PreviewBoxCategory.vue?vue&type=template&id=6a7a1a8e&scoped=true&"
import script from "./PreviewBoxCategory.vue?vue&type=script&lang=js&"
export * from "./PreviewBoxCategory.vue?vue&type=script&lang=js&"
import style0 from "./PreviewBoxCategory.vue?vue&type=style&index=0&id=6a7a1a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a1a8e",
  null
  
)

export default component.exports